/** Internal option: keep the default JSON generation path free of provenance allocations. */
export const EXAMPLE_EVALUATION = Symbol('example-evaluation');
